import { apiSlice } from '../../api/apiSlice';
import { IMPERSONATOR_DETAIL, USER_REPORTEES_COUNT} from '../../constants';

export const impersonateSlice = apiSlice.injectEndpoints({
     endpoints : (builder : any) => ({
         getImpersonatorDetail :builder.query({
            query :(arg: any) => {
                const {impersonatorOracleId,impersonatedOracleId} = arg;
                return{
                    url : IMPERSONATOR_DETAIL,
                    params: {impersonatorOracleId,impersonatedOracleId},
                };
            },
         }),
         getUserReporteesCount :builder.query({
            query :(arg: any) => {
                const {employeeNumber} = arg;
                return{
                    url : USER_REPORTEES_COUNT,
                    params: {employeeNumber},
                };
            },
         }),
     }),
});

export const {
    useGetImpersonatorDetailQuery,
    useGetUserReporteesCountQuery

} = impersonateSlice;